import {NgModule} from '@angular/core';
import {ClickOutsideDirective} from 'src/directives/clickoutside.directive';
import {InputLowerCaseDirective} from 'src/directives/input-lowercase.directive';
import {InputUpperCaseDirective} from 'src/directives/input-uppercase.directive';
import {InterceptRouterLinkDirective} from 'src/directives/intercept-routerlink.directive';
import {VarDirective} from 'src/directives/ng-var.directive';
import {PwcToastDirective} from 'src/directives/pwc-toast.directive';
import {ToggleClassOnClickDirective} from 'src/directives/toggle-class-on-click.directive';
import {ToggleClassOnHoverDirective} from 'src/directives/toggle-class-on-hover.directive';
import {AutofocusDirective} from 'src/directives/autofocus.directive';

const directives = [
  AutofocusDirective,
  ClickOutsideDirective,
  InputLowerCaseDirective,
  InputUpperCaseDirective,
  InterceptRouterLinkDirective,
  PwcToastDirective,
  ToggleClassOnClickDirective,
  ToggleClassOnHoverDirective,
  VarDirective
];

@NgModule({
  imports: [],
  declarations: directives,
  exports: directives,
})
export class SharedDirectivesModule {}
